/* eslint-disable react/jsx-filename-extension */
import { render } from 'preact';
import { Ad } from '~/shared/containers/Ad';

(function page($mountNode) {
  render(<Ad slot="popular.listing" />, $mountNode);
})(document.getElementById('custom-ad-slot'));
